<template>
  <v-simple-table class="date_view_table">
    <tr v-for="(item, index) in data" v-bind:key="index">
      <!-- <td v-for="(b, index) in item" v-bind:key="index">
        <ul>
          {{
            b.date
          }}
        </ul>
      </td> -->
      <td
        @click="choose(b)"
        v-for="(b, index) in item"
        v-bind:key="index"
        v-bind:class="
          b.found ? (b.data.status == 1 && b.data.type == 1 ?'selected-phone ':( b.data.status == 1 && b.data.type == 2 ) ? 'selected-person': ( b.data.status == 1 && b.data.type == 3 ) ?'selected-inno':'selected-not-go'): 'not-selected'"
      >
        <ul>
          {{
            b.date
          }}
        </ul>
      </td>
    </tr>
    <visit-date-detail
      @close="detailShow = false"
      v-bind:show="detailShow"
      v-bind:detailData="detailData"
    ></visit-date-detail>
  </v-simple-table>
</template>

<script>
import Detail from "./Detail.vue";
export default {
  props: ["dates"],
  data() {
    return {
      detailData: null,
      detailShow: false,
    };
  },
  methods: {
    choose(item) {
      if (item && item.found) {
        this.detailData = item.data;
        this.detailShow = true;
      }
    },
    checkInExist(currentDate) {
      //var go = false;
      //var status;
      // this.visit_dates.map(val => {
      //     if (val.date == currentDate.date) {
      //         go = true;
      //         status = val.status;
      //     }
      // });
      // if (go) {
      return {
        date: currentDate.date,
        choose: true,
        status: true,
      };
      // } else {
      //     return null;
      // }
    },
  },
  computed: {
    data() {
      var filterDate = [];
      var arr = [];
      this.dates.map((val, index) => {
        arr.push(val);
        var number = parseInt(index) + 1;
        if (number % 7 == 0) {
          filterDate.push(arr);
          arr = [];
        }
      });
      //var leftLength = this.dates.length - filterDate.length;
      var bb = [];
      for (var i = filterDate.length * 7; i < this.dates.length; i++) {
        bb.push(this.dates[i]);
      }
      filterDate.push(bb);
      filterDate.map((val) => {
        val.map((val) => {
          var returnData = this.checkInExist(val);
          if (returnData) {
            val.choose = returnData.choose;
            val.status = returnData.status;
          }
        });
      });
      return filterDate;
    },
  },
  components: {
    "visit-date-detail": Detail,
  },
};
</script>

<style scoped>
.date_view_table td {
  padding: 10px !important;
}
td {
  font-size: 18px !important;
  text-align: center;
}
td.selected-person {
  background: blue;
  color: white;
  
}
td.selected-phone {
  background-color: #1E90FF; 
  color: white;
}
td.selected-inno {
  background-color: #24b014; 
  color: white;
}
td.selected-not-go {
  background: red;
  color: white;
}
ul {
  list-style-type: none;
}

/* legend */
.color-box-container {
  display: flex;
  align-items: center;
  margin: 5px 0; 
}

.color-box-row {
  display: flex; /* Align items in a row */
  align-items: center; /* Align color boxes and text vertically */
}


.color-box {
  width: 16px; 
  height: 16px;
  border-radius: 3px;
  margin-right: 8px; 
  border: 1px solid #000; 
}

.color-box-container span {
  font-size: 14px; 
  color: #333;
}
</style>

